import React, { Component } from "react";
import { connect } from "react-redux";
import { changeBColorAction, changeExVarCatAction, changeExVarNameAction, changeExVarNameOptAction } from "../../redux/boring/actions";
import ExVar from "../common/ExVar";
import Lgd, { probLgd } from "../common/Lgd";
import Select from "../common/Select";

const mapStateToProps = (state) => {
    return {
        bColor: state.boringReducer.bColor,
        exVarCat: state.boringReducer.exVarCat,
        exVarName: state.boringReducer.exVarName,
        exVarNameOpt: state.boringReducer.exVarNameOpt,
    };
};

const colorOpt = [{ val: "exVar", text: "説明変数" }];

class Main extends Component {
    /*★ここから公開版で削除*/
    //    constructor(props) {
    //        super(props);
    //        this.apply = this.apply.bind(this);
    //        window.setDrawView();
    //    }
    //
    //    /*
    //     * ボーリングカラー変更
    //     * @since hara 2021-02-24
    //     */
    //    apply() {
    //    }

    render() {
        {
            /*
        let cont = null;
        if (this.props.bColor === 'exVar') {
            cont =
                <div>
                    <ExVar exVarCat={this.props.exVarCat} exVarName={this.props.exVarName} exVarNameOpt={this.props.exVarNameOpt}
                        exVarCatAction={changeExVarCatAction} exVarNameAction={changeExVarNameAction} exVarNameOptAction={changeExVarNameOptAction} />
                    <div className='l-right l-mtS'><button className='sBtn' onClick={this.apply}>適用</button></div>
                    <div className='l-mtS'></div>
                    <Lgd data={probLgd} cat='dist' width='all' />
                    <fieldset className='Unit l-mtS'>
                        <legend>説明</legend>
                        <p>ボーリングクリック：距離表示</p>
                    </fieldset>
                </div>
        }
        */
        }

        return {
            /*
            <div className='TopBtnSwL'>
                <Select label='ボーリングカラー' options={colorOpt} value={this.props.bColor} class='selectM' blank={false} action={changeBColorAction} />
                {cont}
            </div>
            */
        };
    }
    /*★ここまで公開版で削除*/
}

export default connect(mapStateToProps)(Main);
